module.exports = __webpack_public_path__ + "img/page_activasolo_slider01.6a1cddbd.png";